import type { OpeningHour } from '@sazerac/design-tokens';

/**
 * Renders weekly hours, collapsing consecutive days that share the same times into a
 * range ("Mon–Thu 8:00–00:00"), which is how the approved design presents them.
 */
export function OpeningHoursList({ hours, className = '' }: { hours: OpeningHour[]; className?: string }) {
  if (!hours?.length) return null;

  const groups: { days: string[]; label: string }[] = [];

  for (const hour of hours) {
    const label = hour.isClosed ? 'Closed' : `${hour.opens}–${hour.closes}`;
    const previous = groups[groups.length - 1];
    if (previous && previous.label === label) previous.days.push(hour.day);
    else groups.push({ days: [hour.day], label });
  }

  return (
    <dl className={`sz-hours ${className}`}>
      {groups.map((group) => (
        <div key={group.days.join('-')} className="sz-hours__row">
          <dt className="sz-hours__days">{formatDayRange(group.days)}</dt>
          <dd className="sz-hours__times">{group.label}</dd>
        </div>
      ))}
    </dl>
  );
}

function formatDayRange(days: string[]): string {
  const short = (day: string) => day.slice(0, 3);
  if (days.length === 1) return short(days[0]);
  return `${short(days[0])}–${short(days[days.length - 1])}`;
}
